import { constants } from "../../misc/constants";
import Scenario2 from "./Scenario2";
import { FullPageQuizQuestion } from "../../components/ui/FullPageQuizUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario2Part8 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-2-1',
        chapterCinematic62: 'medsurg-cinematic-2-62', //CAN BE REPLACED - update from Alan - did not get a new specific ending variation for enrique from the art team.
        chapterCinematic63: 'medsurg-cinematic-2-63',
        chapterCinematic64: 'medsurg-cinematic-2-64',
        chapterCinematic65: 'medsurg-cinematic-2-65',
        chapterCinematic66: 'medsurg-cinematic-2-66',
        chapterCinematic67: 'medsurg-cinematic-2-67',
        chapterCinematic68: 'medsurg-cinematic-2-68',
	}

	constructor(scenario: Scenario2, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private RememberDisplayed: boolean = false;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action21: boolean = false;
	private Action22: boolean = false;
	private Action23: boolean = false;
	private Action24: boolean = false;
	private Action25: boolean = false;
	private Action61: boolean = false;
	private Action62: boolean = false;
	private Action63: boolean = false;
	private Action64: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private DRbool: boolean = false;

	
	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part8.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario2/video3' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario2/video30.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
        this.scenario.displayModalPop(
			null,
            'Skipping to part 9',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "Mr. Ramirez has returned from his X-ray.",
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '3', '0', false, true);
				context.TalkCount = 3;
				context.ActionCount = 0;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(3550, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
			title: 'Vitals - 18:00'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
			visit: context.scenario.visit4,
			lineBreak: true,
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario2).PrRamirezID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario2).PrRamirezID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkDescribe();
					},
					disable: () => this.Talk3
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "The right side of my chest really hurts; I don't feel like I can breathe.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'General',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Arm(s)',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Leg(s)',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Head',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Chest',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic65, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 7,
			extBottom: true,
			extText: "7 - It's worse than before",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic66, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment1TalkDescribe() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "It really hurts - I still have that sharp, stabbing pain but it's worse.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'Pain Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Stabbing',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Sharp',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Tender',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Throbbing',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic67, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment2PreloadUis();
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, true)
		};
	}

	private segment2PreloadUis() {
        var context = this;
		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Chest Tube',
					onClicked: () => {
						this.segment1ActionTube();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1;
		context.TalkCount = 0;
		context.getFooterCounts2();
	}

	private segment1ActionTube() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Actions',
			toppx: '70px',
			titletext: 'Chest Tube',
			isTalks: true,
			extTop: true,
			extImg: 't23', //NEED IMAGE
			extText: 'Tube is kinked',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.chestAssessment,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.chestAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action1 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Chest Tube Assessment',
					talktext2: 'Assess Tube',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Clots present',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Dependent loops present',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Kinked or compressed',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.showFullPageQuiz();
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), true, false)
		};
	}

	private showFullPageQuiz() {
		var context = this;
		context.scenario.update508Window(Window508Type.FullPageQuiz)
		var FPinstance = this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.FullPageQuizUI, {
			questions: [
				{
					title: 'Do you want to unking the tube?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: "That is not the correct choice. Please try again."
				},
			],
			onSingleQuestionSubmitted: (question: FullPageQuizQuestion) => {
				var correctOptions = question.options.filter(o => o.isCorrect);
				
				var correctPoints = 0;
				correctOptions.forEach(co => correctPoints += co.points);

				var selectedOptions = question.options.filter(o => o.isSelected);
				var correctSelectedOptions = question.options.filter(o => o.isCorrect && o.isSelected);
				var isCorrect = correctOptions.length === correctSelectedOptions.length && selectedOptions.length === correctOptions.length;
				if(isCorrect) {
					context.scenario.updateScore(450);
				} else {
					this.scenario.gameManager.UiManager.hideUiInstance(FPinstance);
					this.scenario.showFeedback(question.incorrectFeedback, () => {
						this.scenario.gameManager.UiManager.showUiInstance(FPinstance);
						this.scenario.update508Window(Window508Type.FullPageQuiz)
					})
				}

				return isCorrect;
			},
			onDone: () => {
				context.scenario.gameManager.UiManager.destroyUIInstanceById(FPinstance);
				context.scenario.update508Window(Window508Type.TalkActionsUI)
				context.segment3PreloadUis();
			}
		});	
	}

	private segment3PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment2ActionVitals();
					},
					disable: () => this.Action2
				},
				{
					toppx: '150px',
					titletext: 'Please take a deep breath and then cough',
					onClicked: () => {
						context.segment2ActionCough();
					},
					disable: () => this.Action3
				},
				{
					toppx: '250px',
					titletext: 'Assess Respiratory Status',
					onClicked: () => {
						context.segment2ActionStatus();
					},
					disable: () => this.Action4
				},
				{
					toppx: '350px',
					titletext: 'Assess chest tube dressing',
					onClicked: () => {
						context.segment2ActionDressing();
					},
					disable: () => this.Action5
				},
				{
					toppx: '450px',
					titletext: 'Assess Patient',
					onClicked: () => {
						context.segment2ActionAssess();
					},
					disable: () => this.Action6
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 8;
		context.getFooterCounts3();
	}

	private segment2ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment2ActionTemperature();
					},
					disable: () => this.Action21
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment2ActionBloodPressure();
					},
					disable: () => this.Action22
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment2ActionPulse();
					},
					disable: () => this.Action23
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment2ActionRespirations();
					},
					disable: () => this.Action24
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment2ActionSatLevel();
					},
					disable: () => this.Action25
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment2ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'Assess Chest Tube and System: Suction',
					onClicked: () => {
						context.segment2ActionSuction();
					},
					disable: () => this.Action61
				},
				{
					toppx: '150px',
					titletext: 'Assess Chest Tube and System: Drainage Color and Volume',
					onClicked: () => {
						context.segment2ActionColor();
					},
					disable: () => this.Action62
				},
				{
					toppx: '250px',
					titletext: 'Assess Chest Tube and System: Tidaling',
					onClicked: () => {
						context.segment2ActionTidaling();
					},
					disable: () => this.Action63
				},
				{
					toppx: '350px',
					titletext: 'Assess Chest Tube and System: Leakage',
					onClicked: () => {
						context.segment2ActionLeakage();
					},
					disable: () => this.Action64
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment2ActionTemperature() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '99.0',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action21 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Temperature : 99.0</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '110/76',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action22 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Blood Pressure : 110/76</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionPulse() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '88',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action23 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Pulse : 88</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionRespirations() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '24',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action24 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>Respirations : 24</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionSatLevel() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '95% 2L supplemental O2',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action25 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezVitalsID, {
					list: '<li>02 Sat Level : 95% 2L supplemental O2</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionCough() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Please take a deep breath and then cough.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(250);
				this.Action3 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts3();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic68, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
		});
	}

	private segment2ActionStatus() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			titletext: "Assess Respiratory Status",
			isTalks: true,
			extBottom: true,
			extText: 'Right side: breath sounds are decreased <br>Left Side: breath sounds are normal',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.respiratoryStatus,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.respiratoryStatus)
					}
				}
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.playVideoChapter(this.chapterIds.chapterCinematic63, () => {}, true);
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts3();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 125,
					binaryq: true,
					talktext1: 'Respiratory Status',
					talktext2: 'Thoracic Cage Expansion',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Symmetrical',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Asymmetrical',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 4,
					prequizheight: 2,
					quiztop: '310px',
					maxPoints: 125,
					talktext1: 'Respiratory Status',
					talktext2: 'Breath Sounds',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Absent',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Clear on both sides',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Decreased on left, clear on right',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Decreased on right, clear on left',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic64, () => {}, true);
	}

	private segment2ActionDressing() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			titletext: "Assess chest tube dressing",
			isTalks: true,
			extTop: true,
			extImg: 't24', //NEED IMAGE
			extText: 'Crepitus is not present',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
					title: context.scenario.chestTube,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.chestTube)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action5 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts3();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 50,
					talktext1: 'Chest Tube and System',
					talktext2: 'Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Bleeding',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Air leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Clean and Dry',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 2,
					prequizheight: 4,
					quiztop: '310px',
					maxPoints: 50,
					binaryq: true,
					talktext1: 'Chest Tube and System',
					talktext2: 'Is Crepitus present?',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionSuction() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '70px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Suction",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action61 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Suction',
					talks: [
						{
							buttontop: '150px',
							buttontext: '-10 cm',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '-20 cm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '-40 cm',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionColor() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Drainage Color and Volume",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			extText: 'Previous shift output is 400mL in 12 hours',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action62 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 200,
					talktext1: 'Drainage System',
					talktext2: 'Drainage Color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Dark red',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Pink',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Cloudy',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 200,
					talktext1: 'Drainage System',
					talktext2: 'Drainage Volume',
					talks: [
						{
							buttontop: '150px',
							buttontext: '0 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '50 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '100 mL',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '600 mL',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: '700 mL',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionTidaling() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Tidaling",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action63 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Tidaling',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Not present',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionLeakage() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			loadQuiz: true,
			titletext: "Assess Chest Tube and System: Leakage",
			isTalks: true,
			extTop: true,
			extTopVideo: './assets/videos/general/loop1.mp4',
			extText: 'There is no air leakage',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.DRbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
						title: context.scenario.drainageSystem,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3);
					this.DRbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario2).ramirezNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit3, context.scenario.drainageSystem)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action64 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Drainage System',
					talktext2: 'Leakage',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Presistent leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Intermittent leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No air leakage',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts3() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.scenario.update508Window(Window508Type.Main);
			context.segment1Part5Debrief();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action21 === true && this.Action22 === true && this.Action23 === true && this.Action24 === true && this.Action25 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);	
			this.Action2 = true;
			this.ActionCount = this.OldActionCount - 1;
		};
		context.getFooterCounts3();
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action61 === true && this.Action62 === true && this.Action63 === true && this.Action64 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action6 = true;
		};
		context.getFooterCounts3();
	}
}